import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isImageDeviation } from '../../DeviationViews/_helpers';
import Dumbo from '../../DeviationViews/Dumbo';
import s from './SystemNotificationIcon.scss';
const ICON_DESKTOP_SIZE = 50;
const ICON_MOBILE_SIZE = 77;
// C96
export const SystemNotificationIcon = ({ iconComponent: IconComponent, backgroundDeviation })=>{
    const isMobile = useContext(MobileContext);
    const iconSize = isMobile ? ICON_MOBILE_SIZE : ICON_DESKTOP_SIZE;
    const hasBackground = backgroundDeviation && isImageDeviation(backgroundDeviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], !hasBackground && s['empty-background'])
    }, hasBackground && backgroundDeviation && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Dumbo, {
        className: s['thumb'],
        deviation: backgroundDeviation,
        width: iconSize,
        height: iconSize
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['overlay']
    })), /*#__PURE__*/ React.createElement(IconComponent, {
        className: s['icon'],
        customSizable: true
    }));
};
SystemNotificationIcon.displayName = 'SystemNotificationIcon';
export default SystemNotificationIcon;
